import Vue from 'vue'
import { Component } from 'vue-property-decorator'

import { ApolloResponse } from '@/interfaces/apollo'
import { getCandidateProducers } from '@/modules/Producer/gql/producer.gql'
import { Producer } from '@/modules/Producer/interfaces/producer'
import { showErrors } from '@/utils/snack'

@Component
export default class SearchProducer extends Vue {
  candidatesProducer: Producer[] = []

  get candidatesProducerOptions () {
    return this.candidatesProducer.map(item => {
      return {
        id: +item.id,
        name: item.name
      }
    })
  }

  async mounted () {
    this.getCandidateProducers()
  }

  async getCandidateProducers (val?: string) {
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getCandidateProducers,
        variables: {
          filter: {
            name: val
          },
          paging: {
            offset: 0,
            limit: 100
          }
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.candidatesProducer = this.$R.sortBy(this.$R.compose(this.$R.toLower, this.$R.prop('name')))(result.data.getProducers.producers)
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }
}
